export default __webpack_public_path__ + "static/media/GTFS_Comparator_Logo.8fe73bc8.svg";